<template>
    <div>
        <b-container fluid>
            <b-row>
                <b-col cols="12">
                    <div class="grid-parent" v-if="photos">
                        <ProjectBox v-for="project in photos" :key="'photo_'+project.id" :project="project" :project-type="'photo'" class="grid-child grid-child-third" :isShowcase="false"></ProjectBox>
                    </div>
                </b-col>
            </b-row>
        </b-container>

        <!--        <div v-if="photos">-->
        <!--            &lt;!&ndash;            <ProjectBox v-for="project in photos" :key="'photo_'+project.id" :project="project" :project-type="'photo'"></ProjectBox>&ndash;&gt;-->
        <!--            <b-row>-->
        <!--                <b-col cols="12" md="4" v-for="project in photos">-->
        <!--                    <ProjectBox :key="'photo_'+project.id" :project="project" :project-type="'photo'"></ProjectBox>-->
        <!--                </b-col>-->
        <!--            </b-row>-->
        <!--        </div>-->
    </div>
</template>

<script>
    import ProjectBox from "../components/ProjectBox";
    import _ from "lodash";

    export default {
        name: "PhotosPage",
        components: {ProjectBox},
        computed: {
            photos: function () {
                return _.orderBy(this.$store.state.works.photos, 'sortscore', 'desc')
            }
        },
        mounted() {
            this.$store.dispatch('GET_PHOTOS_FROM_API')
        }
    }
</script>

<style scoped lang="scss">
@import "../custom";
</style>